module.exports = __webpack_public_path__ + "files/edafa1647593124f3d8894922e789ba7.svg";